import { Tag, Tooltip } from 'antd';
import { ProcessL4 } from 'store/ducks/Reporting/types';
import * as Styled from './RiskInventory.styled';
import * as ReportingStyled from '../Reporting.styled';
import { GlobalToken } from 'antd/es/theme/interface';

export const getColumns = (token: GlobalToken) => [
  {
    title: 'Risk Title',
    dataIndex: 'risk_title',
    key: 'risk_title',
    width: 200
  },
  {
    title: 'Description',
    dataIndex: 'description',
    key: 'description',
    width: 200
  },
  {
    title: 'Description 1',
    dataIndex: 'description_1',
    key: 'description_1',
    width: 200
  },
  {
    title: 'Description 2',
    dataIndex: 'description_2',
    key: 'description_2',
    width: 200
  },
  {
    title: 'Category',
    dataIndex: 'category',
    key: 'category',
    width: 120
  },
  {
    title: 'Root Cause',
    dataIndex: 'root_cause',
    key: 'root_cause',
    width: 180
  },
  {
    title: 'Event',
    dataIndex: 'event',
    key: 'event',
    width: 180
  },
  {
    title: 'Key Risk Indicators',
    dataIndex: 'key_risk_indicators',
    key: 'key_risk_indicators',
    width: 180
  },
  {
    title: 'Impact/Consequence',
    dataIndex: 'impact_consequence',
    key: 'impact_consequence',
    width: 180
  },
  {
    title: 'Risk Assessment Score',
    dataIndex: 'risk_assessment_score',
    key: 'risk_assessment_score',
    width: 150
  },
  {
    title: 'Risk Owner',
    dataIndex: 'instance_risk_owner',
    key: 'instance_risk_owner',
    width: 150
  },
  {
    title: 'Owner Maintainer',
    dataIndex: 'owner_maintainer',
    key: 'owner_maintainer',
    width: 150
  },
  {
    title: 'Comments',
    dataIndex: 'comments',
    key: 'comments',
    width: 200
  },
  {
    title: 'Assessment Date',
    dataIndex: 'instance_assessment_date',
    key: 'instance_assessment_date',
    width: 120
  },
  {
    title: (
      <ReportingStyled.ReportValidityHeaderWrapper>
        Risk validity from - to
      </ReportingStyled.ReportValidityHeaderWrapper>
    ),
    key: 'risk_validity',
    onHeaderCell: () => ({
      style: Styled.riskInventoryHeaderStyle
    }),
    children: [
      {
        title: '',
        dataIndex: 'instance_start_date',
        key: 'instance_start_date',
        width: 120,
        onHeaderCell: () => ({
          style: Styled.riskInventoryDateHeaderStyle
        }),
        onCell: () => ({
          style: Styled.riskInventoryStartDateCellStyle
        })
      },
      {
        title: '',
        dataIndex: 'instance_end_date',
        key: 'instance_end_date',
        width: 120,
        onHeaderCell: () => ({
          style: Styled.riskInventoryDateHeaderStyle
        })
      }
    ]
  },
  {
    title: 'Control Level',
    dataIndex: 'control_level_name',
    key: 'control_level_name',
    width: 120
  },
  {
    title: 'Probability of Occurrence',
    dataIndex: 'probability_of_occurrence_name',
    key: 'probability_of_occurrence_name',
    width: 180
  },
  {
    title: 'Severity',
    dataIndex: 'severity_name',
    key: 'severity_name',
    width: 100
  },
  {
    title: 'Speed of Occurrence',
    dataIndex: 'speed_of_occurrence_name',
    key: 'speed_of_occurrence_name',
    width: 150
  },
  {
    title: 'Risk Status',
    dataIndex: 'risk_status_name',
    key: 'risk_status_name',
    width: 120
  },
  {
    title: 'Risk Trend',
    dataIndex: 'risk_trend_name',
    key: 'risk_trend_name',
    width: 120
  },
  {
    title: 'Update Cycle',
    dataIndex: 'update_cycle_name',
    key: 'update_cycle_name',
    width: 120
  },
  {
    title: 'Business Process',
    dataIndex: 'business_process_l4_title',
    key: 'business_process_l4_title',
    width: 180
  },
  {
    title: 'Group Name',
    dataIndex: 'group_name',
    key: 'group_name',
    width: 120
  },
  {
    title: 'Division Name',
    dataIndex: 'division_name',
    key: 'division_name',
    width: 150
  },
  {
    title: 'Region Name',
    dataIndex: 'region_name',
    key: 'region_name',
    width: 120
  },
  {
    title: 'Legal Entity Name',
    dataIndex: 'legal_entity_name',
    key: 'legal_entity_name',
    width: 180
  },
  {
    title: 'Business Unit Name',
    dataIndex: 'business_unit_name',
    key: 'business_unit_name',
    width: 180
  }
];
